
@switch (valueEntryType) {
  @case ('none') {
    <!-- EMPTY -->
  }
  @case ('single') {
    <rl-data-behavior-single-value-entry [cmd]="cmd" [control]="form.controls.value">
    </rl-data-behavior-single-value-entry>
  }
  @case ('range') {
    <div class="d-flex align-items-center flex-wrap" [class.has-error]="form.hasError('invalidRange')">
      <rl-data-behavior-single-value-entry [cmd]="cmd" [control]="form.controls.rangeValue1" class="mb-1">
      </rl-data-behavior-single-value-entry>
      <span class="d-block m-1">and</span>
      <rl-data-behavior-single-value-entry [cmd]="cmd" [control]="form.controls.rangeValue2" class="mb-1">
      </rl-data-behavior-single-value-entry>
    </div>
    @if (form.hasError('invalidRange')) {
      <div class="text-danger">
        Range is invalid.
      </div>
    }
  }
}
